import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _$33190$36012$;
var EXT_FLOAT_WEBGL2 = 'EXT_color_buffer_float';
export default (_$33190$36012$ = {}, _defineProperty(_$33190$36012$, 33189, {
  bpp: 2
}), _defineProperty(_$33190$36012$, 33190, {
  gl2: true,
  bpp: 3
}), _defineProperty(_$33190$36012$, 36012, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 36168, {
  bpp: 1
}), _defineProperty(_$33190$36012$, 34041, {
  bpp: 4
}), _defineProperty(_$33190$36012$, 35056, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 36013, {
  gl2: true,
  bpp: 5
}), _defineProperty(_$33190$36012$, 32854, {
  bpp: 2
}), _defineProperty(_$33190$36012$, 36194, {
  bpp: 2
}), _defineProperty(_$33190$36012$, 32855, {
  bpp: 2
}), _defineProperty(_$33190$36012$, 33321, {
  gl2: true,
  bpp: 1
}), _defineProperty(_$33190$36012$, 33330, {
  gl2: true,
  bpp: 1
}), _defineProperty(_$33190$36012$, 33329, {
  gl2: true,
  bpp: 1
}), _defineProperty(_$33190$36012$, 33332, {
  gl2: true,
  bpp: 2
}), _defineProperty(_$33190$36012$, 33331, {
  gl2: true,
  bpp: 2
}), _defineProperty(_$33190$36012$, 33334, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 33333, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 33323, {
  gl2: true,
  bpp: 2
}), _defineProperty(_$33190$36012$, 33336, {
  gl2: true,
  bpp: 2
}), _defineProperty(_$33190$36012$, 33335, {
  gl2: true,
  bpp: 2
}), _defineProperty(_$33190$36012$, 33338, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 33337, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 33340, {
  gl2: true,
  bpp: 8
}), _defineProperty(_$33190$36012$, 33339, {
  gl2: true,
  bpp: 8
}), _defineProperty(_$33190$36012$, 32849, {
  gl2: true,
  bpp: 3
}), _defineProperty(_$33190$36012$, 32856, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 32857, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 36220, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 36238, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 36975, {
  gl2: true,
  bpp: 4
}), _defineProperty(_$33190$36012$, 36214, {
  gl2: true,
  bpp: 8
}), _defineProperty(_$33190$36012$, 36232, {
  gl2: true,
  bpp: 8
}), _defineProperty(_$33190$36012$, 36226, {
  gl2: true,
  bpp: 16
}), _defineProperty(_$33190$36012$, 36208, {
  gl2: true,
  bpp: 16
}), _defineProperty(_$33190$36012$, 33325, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 2
}), _defineProperty(_$33190$36012$, 33327, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 4
}), _defineProperty(_$33190$36012$, 34842, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 8
}), _defineProperty(_$33190$36012$, 33326, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 4
}), _defineProperty(_$33190$36012$, 33328, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 8
}), _defineProperty(_$33190$36012$, 34836, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 16
}), _defineProperty(_$33190$36012$, 35898, {
  gl2: EXT_FLOAT_WEBGL2,
  bpp: 4
}), _$33190$36012$);